export function SiteBanners() {
  return <div className="shrink-0"></div>;
}
